import APIS_CONSTANTS from "./ApiConstants";
import http from "./http";

class QuestsServices {
  getQuests(campaign) {
    return http.get(`${APIS_CONSTANTS.getQuests}?campaign=${campaign}`);
  }

  getQuestById(id) {
    return http.get(`${APIS_CONSTANTS.getQuests}/${id}`);
  }
}

export default new QuestsServices();
